module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? '' : _ref$body,
    _ref$actionLabel = _ref.actionLabel,
    actionLabel = _ref$actionLabel === void 0 ? '' : _ref$actionLabel,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? '' : _ref$action;
  var bodyHtml = body ? "<p>".concat(body, "</p>") : '';
  var cta = actionLabel ? "<button type=\"button\" class=\"saito-button-primary\" data-action=\"".concat(action || 'sell', "\">").concat(actionLabel, "</button>") : '';
  return "\n    <div class=\"empty\">\n      <h2>".concat(title, "</h2>\n      ").concat(bodyHtml, "\n      ").concat(cta, "\n    </div>\n  ");
};